import { useEffect } from 'react'
import displayPinpoll from '../../modules/display-pinpoll'
import checkPinpollLogin from '../../modules/check-pinpoll-login'
import onVote from '../../modules/on-vote'
import isStolApp from '../../../../../is-stolapp'
import addAPPMessageBox from '../../modules/add-app-message-box'
import addRegisterForm from '../../modules/add-register-form'
import consoleLogger from '../../../../../console-logger'
import useReadyPiano from '../../../../../../vendor/Piano/modules/use-ready-piano'
import useViewPinpoll from '../../modules/use-view-pinpoll'

const LockedPinpoll = ({ pinpollId, ready }) => {
  const [consoleLog] = consoleLogger('Pinpoll')
  const isReadyPiano = useReadyPiano()
  const { voted, elementId } = useViewPinpoll()

  useEffect(() => {
    window.displayPinpoll = displayPinpoll
    window.checkPinPollLogin = checkPinpollLogin

    const pinPoll = document.getElementById('pinpollParentNode')
    pinPoll.style = 'visibility:hidden; height: 0;'

    const pinpollevent = window.addEventListener('message', onVote)
    return () => {
      if (pinpollevent) {
        pinpollevent.remove()
      }
    }
  }, [])
  useEffect(() => {
    consoleLog('is Piano ready', isReadyPiano)
    if (!isReadyPiano || !ready) {
      return
    }

    const sameIds = elementId === pinpollId
    const undefinedIds = elementId === undefined || pinpollId === undefined
    consoleLog('ids still undefined?', undefinedIds)
    consoleLog('same id like pinpoll?', sameIds)

    if (!sameIds || undefinedIds) {
      consoleLog('IDS not the same or undefined', sameIds)
      return
    }
    consoleLog('is User logged in? ', tp.pianoId.isUserValid())
    consoleLog('alread voted? ', voted)

    if (tp.pianoId.isUserValid() || !voted) {
      consoleLog('SHOW ', 'PINPOLL')
      displayPinpoll()
      return
    }
    consoleLog('HIDE ', 'PINPOLL')
    const pinPoll = document.getElementById('pinpollParentNode')
    if (isStolApp()) {
      addAPPMessageBox(pinPoll)
    } else {
      addRegisterForm(pinPoll)
    }
  }, [isReadyPiano, ready, voted, elementId])

  return true
}

export default LockedPinpoll
